<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import checkIsMobile from "@/utils/checkIsMobile";
    import ReviewsTotalRate from "@apps/reviews/components_v2/ReviewsTotalRate/ReviewsTotalRate.svelte";
    import { REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE } from "@apps/reviews/constants";
    import ReviewsListInfoEntity from "@apps/reviews/entities/ReviewsListInfoEntity";
    import Button from "@components_v2/Button/Button.svelte";
    import Tooltip from "@components_v2/Tooltip/Tooltip.svelte";
    import { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
    import { createEventDispatcher } from "svelte";

    import ReviewsStarRatingSummary from "./ReviewsStarRatingSummary.svelte";

    export let status: STATUS;
    export let reviewsCount: number;
    export let averageReviewsRating: number;
    export let ratesInfo: ReviewsListInfoEntity["ratesInfo"] = [];
    export let widgetDisplayStyle: REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE;
    export let gwI18n: GwI18n;
    const dispatch = createEventDispatcher();
    const handleGoToReviews = () => {
        dispatch("goToReviews");
    };
    const seeAllReviewsText$ = gwI18n.selectT(
        "reviews.ReviewsStarRatingWidget",
        "see_all_reviews"
    );
    const isMobile = checkIsMobile();
</script>

{#if status === STATUS.READY && reviewsCount === 0}
    <Button
        mode="link"
        size="small"
        ariaLabel="Write a review"
        on:click={handleGoToReviews}
    >
        <ReviewsStarRatingSummary
            {averageReviewsRating}
            {reviewsCount}
            displayStyle={widgetDisplayStyle}
            {gwI18n}
        />
    </Button>
{:else}
    <Tooltip
        maxWidth="240px"
        position="bottom-start"
        xPosition={isMobile ? 0 : -6}
    >
        <ReviewsStarRatingSummary
            {averageReviewsRating}
            {reviewsCount}
            displayStyle={widgetDisplayStyle}
            {gwI18n}
        />
        <svelte:fragment slot="content">
            <div class="gw-rv-star-rating__tooltip-content">
                <ReviewsTotalRate
                    {averageReviewsRating}
                    {ratesInfo}
                    {reviewsCount}
                />

                <Button
                    mode="link"
                    ariaLabel="See all Reviews"
                    size="small"
                    on:click={handleGoToReviews}
                >
                    {$seeAllReviewsText$}
                </Button>
            </div>
        </svelte:fragment>
    </Tooltip>
{/if}

<style lang="postcss">
    .gw-rv-star-rating {
        &__tooltip-content {
            display: flex;
            flex-direction: column;
            gap: var(--gw-space-300);
        }
    }
</style>
